var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 205,
    viewBox: "0 0 206 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.0492,
    cy: 41.5157,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.976,
    cy: 59.1768,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.456,
    cy: 68.2463,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200.07,
    cy: 98.3181,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.308,
    cy: 100.347,
    rx: 68.2583,
    ry: 67.6616,
    fill: "#787E8C",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.566 100.347C167.566 137.155 137.462 167.009 100.308 167.009C63.1535 167.009 33.0492 137.155 33.0492 100.347C33.0492 63.539 63.1535 33.6853 100.308 33.6853C137.462 33.6853 167.566 63.539 167.566 100.347Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.61466,
    cy: 69.6783,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.1663,
    cy: 181.851,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92.6701,
    cy: 192.83,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 149.95,
    cy: 179.942,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 123.697,
    cy: 177.078,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 128.47,
    cy: 190.92,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 109.854,
    cy: 196.648,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 174.294,
    cy: 166.815,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 189.568,
    cy: 138.414,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 180.26,
    cy: 123.617,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 184.079,
    cy: 93.5447,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 191.955,
    cy: 77.3156,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 186.466,
    cy: 40.7997,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 73.8157,
    cy: 199.035,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 39.6865,
    cy: 194.262,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 44.4599,
    cy: 185.908,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 13.4332,
    cy: 147.722,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 20.3545,
    cy: 132.925,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 2.69341,
    cy: 94.4994,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 21.5481,
    cy: 64.6664,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 25.3666,
    cy: 22.4226,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 61.8823,
    cy: 6.19333,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 108.422,
    cy: 24.8093,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.437,
    cy: 18.8425,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.475 150.347C169.421 150.347 168.566 149.493 168.566 148.438C168.566 147.384 169.421 146.529 170.475 146.529",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.51199 117.65C7.56648 117.65 8.42131 116.795 8.42131 115.741C8.42131 114.686 7.56648 113.831 6.51199 113.831",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5316 22.4227C75.586 22.4227 76.4409 21.5679 76.4409 20.5134C76.4409 19.4589 75.586 18.6041 74.5316 18.6041",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.833 15.7399C119.778 15.7399 118.923 16.5948 118.923 17.6492C118.923 18.7037 119.778 19.5586 120.833 19.5586",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3305 166.934H16.2972M26.3211 155.836V157.388M38.0157 166.934H39.567M26.3211 176.481V178.271M26.3211 180.658V186.982M21.9058 166.934C24.8891 166.934 26.4404 162.638 26.4404 162.638C26.4404 162.638 26.9178 166.934 30.7364 166.934C29.018 166.934 26.5598 168.486 26.3211 171.588C26.3211 171.588 26.0432 169.048 25.1278 168.128C24.3634 167.359 21.9058 166.934 21.9058 166.934Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.709 30.0597L172.742 30.0597M162.599 45.8116L162.718 39.6063M151.024 30.0597L149.473 30.0597M162.599 20.7517L162.599 8.57984M167.134 30.0597C164.15 30.0597 162.599 34.3557 162.599 34.3557C162.599 34.3557 162.122 30.0597 158.303 30.0597C160.022 30.0597 162.48 28.5084 162.718 25.4057C162.718 25.4057 162.996 27.9459 163.912 28.8664C164.676 29.6349 167.134 30.0597 167.134 30.0597Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5 156V98.3051C45.5 95.8891 46.4713 93.5747 48.1954 91.8823L97.8244 43.1667C101.316 39.7391 106.907 39.7292 110.411 43.1445L158.198 89.7215C159.936 91.4154 160.916 93.7395 160.916 96.1665V156C160.916 160.971 156.886 165 151.916 165H54.5C49.5294 165 45.5 160.971 45.5 156Z",
    fill: "white",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9382 94.1685L85.7697 131.202",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.916 94.5281L122.444 130.483",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0169 163.202L99.4647 127.255C102.246 125.311 105.951 125.334 108.709 127.311L158.758 163.202",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1292 70.3258V94.5281V101.36L89.0056 134.438L104.107 125.09L118.489 134.438L153.365 101.719V94.5281V70.3258C153.365 67.0121 150.679 64.3258 147.365 64.3258H60.1292C56.8155 64.3258 54.1292 67.0121 54.1292 70.3258Z",
    fill: "#F2F3F4",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5 100.662V94.2459V70C54.5 66.6863 57.1863 64 60.5 64H147.5C150.814 64 153.5 66.6863 153.5 70V94.2459V101",
    stroke: "#194590",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.5 80H126.5",
    stroke: "#194590",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.5 89H126.5",
    stroke: "#194590",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7021 104.157H91.5224",
    stroke: "#194590",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6797 104.157H130.354",
    stroke: "#194590",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7021 113.506L130.354 113.506",
    stroke: "#194590",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2926 97.5852C84.8746 97.5852 81.6627 96.2534 79.2454 93.8398C76.8282 91.4262 75.5 88.2106 75.5 84.7926C75.5 81.3746 76.8319 78.1627 79.2454 75.7454C81.659 73.3282 84.8746 72 88.2926 72C91.7106 72 94.9226 73.3319 97.3398 75.7454C99.757 78.159 101.085 81.3746 101.085 84.7926C101.085 88.2106 99.7534 91.4226 97.3398 93.8398C94.9262 96.257 91.7106 97.5852 88.2926 97.5852ZM88.2926 72.1472C84.9151 72.1472 81.7399 73.4643 79.3521 75.8521C76.9643 78.2399 75.6472 81.4151 75.6472 84.7926C75.6472 88.1701 76.9643 91.3453 79.3521 93.7331C81.7399 96.1209 84.9151 97.4381 88.2926 97.4381C91.6701 97.4381 94.8453 96.1209 97.2331 93.7331C99.6209 91.3453 100.938 88.1701 100.938 84.7926C100.938 81.4151 99.6209 78.2399 97.2331 75.8521C94.8453 73.4643 91.6701 72.1472 88.2926 72.1472Z",
    fill: "#194590"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2926 94.2188C85.776 94.2188 83.4103 93.2401 81.6296 91.4594C79.8488 89.6787 78.8701 87.3129 78.8701 84.7963C78.8701 82.2798 79.8488 79.914 81.6296 78.1333C83.4103 76.3526 85.776 75.3739 88.2926 75.3739C90.8092 75.3739 93.1749 76.3526 94.9557 78.1333C96.7364 79.914 97.7151 82.2798 97.7151 84.7963C97.7151 87.3129 96.7364 89.6787 94.9557 91.4594C93.1749 93.2401 90.8092 94.2188 88.2926 94.2188ZM88.2926 75.5137C85.8128 75.5137 83.4839 76.4776 81.7326 78.2326C79.9813 79.9839 79.0136 82.3129 79.0136 84.7927C79.0136 87.2725 79.9776 89.6014 81.7326 91.3527C83.4839 93.104 85.8128 94.0716 88.2926 94.0716C90.7724 94.0716 93.1013 93.1077 94.8526 91.3527C96.6039 89.6014 97.5716 87.2725 97.5716 84.7927C97.5716 82.3129 96.6076 79.9839 94.8526 78.2326C93.1013 76.4813 90.7724 75.5137 88.2926 75.5137Z",
    fill: "#194590",
    stroke: "#194590"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2924 88.4461C86.2762 88.4461 84.6389 86.8089 84.6389 84.7927C84.6389 82.7765 86.2762 81.1392 88.2924 81.1392C90.3086 81.1392 91.9458 82.7765 91.9458 84.7927C91.9458 86.8089 90.3086 88.4461 88.2924 88.4461ZM88.2924 81.2864C86.3608 81.2864 84.7861 82.8611 84.7861 84.7927C84.7861 86.7242 86.3608 88.299 88.2924 88.299C90.224 88.299 91.7987 86.7242 91.7987 84.7927C91.7987 82.8611 90.224 81.2864 88.2924 81.2864Z",
    fill: "#194590",
    stroke: "#194590"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M93.944 87.0848C97.2317 87.0848 99.8969 84.4196 99.8969 81.1319C99.8969 77.8441 97.2317 75.1789 93.944 75.1789C90.6562 75.1789 87.991 77.8441 87.991 81.1319C87.991 84.4196 90.6562 87.0848 93.944 87.0848Z",
    fill: "#194590"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2926 97.5852C84.8746 97.5852 81.6627 96.2534 79.2454 93.8398C76.8282 91.4262 75.5 88.2106 75.5 84.7926C75.5 81.3746 76.8319 78.1627 79.2454 75.7454C81.659 73.3282 84.8746 72 88.2926 72C91.7106 72 94.9226 73.3319 97.3398 75.7454C99.757 78.159 101.085 81.3746 101.085 84.7926C101.085 88.2106 99.7534 91.4226 97.3398 93.8398C94.9262 96.257 91.7106 97.5852 88.2926 97.5852ZM88.2926 72.1472C84.9151 72.1472 81.7399 73.4643 79.3521 75.8521C76.9643 78.2399 75.6472 81.4151 75.6472 84.7926C75.6472 88.1701 76.9643 91.3453 79.3521 93.7331C81.7399 96.1209 84.9151 97.4381 88.2926 97.4381C91.6701 97.4381 94.8453 96.1209 97.2331 93.7331C99.6209 91.3453 100.938 88.1701 100.938 84.7926C100.938 81.4151 99.6209 78.2399 97.2331 75.8521C94.8453 73.4643 91.6701 72.1472 88.2926 72.1472Z",
    fill: "#194590",
    stroke: "#194590"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M77.8288 85.5358C77.0635 85.5358 76.324 85.6388 75.6176 85.8302C75.6764 86.5403 75.7905 87.2319 75.9597 87.9052C76.5484 87.7213 77.1775 87.6219 77.8288 87.6219C81.2946 87.6219 84.1055 90.4329 84.1055 93.8987C84.1055 94.8553 83.8921 95.764 83.5058 96.5771C84.1496 96.8384 84.8229 97.0518 85.5146 97.2063C85.9525 96.1908 86.1953 95.076 86.1953 93.9023C86.1916 89.2813 82.4462 85.5358 77.8288 85.5358Z",
    fill: "#194590"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6121 76.1355C96.7254 75.1826 95.6989 74.3658 94.5583 73.722C95.2574 74.4357 95.6915 75.4107 95.6915 76.4887C95.6915 78.6705 93.9255 80.4365 91.7437 80.4365C89.5619 80.4365 87.7959 78.6705 87.7959 76.4887C87.7959 74.3143 89.5509 72.552 91.7216 72.5409C90.6326 72.2356 89.481 72.0737 88.2963 72.0737C88.1491 72.0737 88.002 72.0773 87.8548 72.081C86.637 73.159 85.868 74.7337 85.868 76.4887C85.868 79.7375 88.4987 82.3681 91.7474 82.3681C94.9961 82.3681 97.6268 79.7375 97.6268 76.4887C97.6231 76.371 97.6157 76.2533 97.6121 76.1355Z",
    fill: "#194590"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 205,
    height: 205,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmails);
export default __webpack_public_path__ + "static/media/emails.f4503115434d48564d2cb2535a038d19.svg";
export { ForwardRef as ReactComponent };